import { apiClient } from './axios';

export interface RagFile {
  id: string;
  configurationId: string;
  isOwner: boolean;
  displayName: string;
  sourceType: string;
  sourceUri: string | null;
  isShared: boolean;
  hasStoragePath: boolean;
  mimeType: string | null;
  sizeBytes: number | null;
  isPublic: boolean;
  publicToken: string | null;
  viewCount: number;
  state: string;
}

export interface MakePublicResponse {
  token: string;
  url: string;
  expiresAt: string | null;
}

export const ragApi = {
  listFiles: async (configurationId: string) => {
    const response = await apiClient.get<RagFile[]>('/rag/files', {
      params: { configurationId },
    });
    return response.data;
  },

  uploadFile: async (configurationId: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('configurationId', configurationId);
    const response = await apiClient.post<RagFile>('/rag/files', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
    return response.data;
  },

  ingestUrl: async (configurationId: string, url: string) => {
    const response = await apiClient.post<RagFile>(
      '/rag/urls',
      { configurationId, url },
      { timeout: 60000 },
    );
    return response.data;
  },

  setShared: async (configurationId: string, id: string, isShared: boolean) => {
    const response = await apiClient.patch<RagFile>(`/rag/files/${id}`, {
      configurationId,
      isShared,
    });
    return response.data;
  },

  deleteFile: async (configurationId: string, id: string) => {
    await apiClient.delete(`/rag/files/${id}`, { params: { configurationId } });
  },

  backfillStorage: async (configurationId: string, id: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('configurationId', configurationId);
    const response = await apiClient.post<RagFile>(`/rag/files/${id}/backfill`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
    return response.data;
  },

  makePublic: async (configurationId: string, id: string, expiresInDays?: number) => {
    const response = await apiClient.post<MakePublicResponse>(`/rag/files/${id}/public`, {
      configurationId,
      expiresInDays,
    });
    return response.data;
  },

  revokePublic: async (configurationId: string, id: string) => {
    await apiClient.delete(`/rag/files/${id}/public`, { params: { configurationId } });
  },

  listAvailableSharedFiles: async (configurationId: string) => {
    const response = await apiClient.get<RagFile[]>('/rag/shared', {
      params: { configurationId },
    });
    return response.data;
  },

  subscribe: async (configurationId: string, ragFileId: string) => {
    await apiClient.post(`/rag/files/${ragFileId}/subscribe`, { configurationId });
  },

  unsubscribe: async (configurationId: string, ragFileId: string) => {
    await apiClient.delete(`/rag/files/${ragFileId}/subscribe`, {
      params: { configurationId },
    });
  },
};
